<div class="page-title-area">
    <div class="container">
      <div class="page-title-content">
        <h2>Release Management</h2>
        <ul>
          <li><a routerLink="/services">Services</a></li>
          <li>Release Management</li>
        </ul>
      </div>
    </div>
  </div>